import { render, staticRenderFns } from "./StockAdjustPreview.vue?vue&type=template&id=63165d98"
import script from "./StockAdjustPreview.vue?vue&type=script&lang=js"
export * from "./StockAdjustPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports